export class ResponseWithContentLength extends Response {
  constructor(body: string) {
    super(body);
    this.headers.set('Content-Length', String(body.length));
  }
}
